import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Visation } from '../models/visation.model';

@Injectable({
  providedIn: 'root',
})
export class VisationService {
  private apiUrl = environment.apiUrl + environment.visation;

  constructor(private http: HttpClient) {}

  getVisations(): Observable<Visation[]> {
    return this.http.get<Visation[]>(this.apiUrl);
  }

  getVisationById(id: number): Observable<Visation> {
    return this.http.get<Visation>(`${this.apiUrl}/${id}`);
  }

  getVisationActionsByAction(action: string): Observable<Visation[]> {
    return this.http.get<Visation[]>(`${this.apiUrl}/action/${action}`);
  }
}
